import { computeLLR }  from '../../utils.js'
import { round } from 'lodash';


// function that updates specificity computation and increasing/decreasing table for realizations and colloc
const updateOccTable= (cumulatedSizes,occTable,incTable,decTable,incDecTable,decIncTable)=> {
  
    if (! occTable) {
      return
    }
    // computing spec for each realization
    const rangeNumber=4; // number of ranges to detect increasing / decreasing real or colloc -- must be > 2
    for (var key of Object.keys(occTable)) {
      
      // initialization of cumulated freq for each big ranges
      const freqByRanges=[];
      for (var j=0;j<rangeNumber;j++) {
        freqByRanges[j]=0;
      }
  
      // add specificity computation for each key of occTable
      const occTableForKey=occTable[key];
      var cumulatedFreq=0;
  
      for (j=0;j<occTableForKey.length;j++) {
        const [f,F,s,S]=[occTableForKey[j][2],occTableForKey[j][3],occTableForKey[j][4],occTableForKey[j][5]];
        cumulatedFreq+=f;
  
        freqByRanges[round(j/occTableForKey.length*rangeNumber)]+=occTableForKey[j][2];
        occTableForKey[j]={
          timeId:occTableForKey[j][1],
          freq:occTableForKey[j][2],
          relFreq:Number((occTableForKey[j][2]/s*1000000).toFixed(2)),
          cumu:cumulatedFreq,
          spec:computeLLR(f,s,F,S,true),
          timeSpec:computeLLR(f,s,cumulatedFreq,cumulatedSizes[occTableForKey[j][1]]),
          size:s,     
        }
      }
      // trends are computed only if there are more than 8 occurrences
      if (cumulatedFreq < 8) {
        continue;
      }
  
      var increasing=true;
      var decreasing=true;
  
      for (j=0;j<rangeNumber-1;j++) {
        increasing=increasing && (freqByRanges[j]<freqByRanges[j+1]);
      }
      if (! increasing) {
        for (j=0;j<rangeNumber-1;j++) {
          decreasing=decreasing && (freqByRanges[j]>freqByRanges[j+1]);
        }
      } else {
        decreasing=false;
      }
  
      if (increasing) {
        incTable[key]= {
          // the ratio between the two first ranges and the two last ranges is computed
          freq:cumulatedFreq,
          coeff:Number(((freqByRanges[rangeNumber-1]+freqByRanges[rangeNumber-2])/(freqByRanges[0]+freqByRanges[1])).toFixed(2)),
          firstAttestation:occTableForKey[0].timeId
        };
      } else if (decreasing) {
          decTable[key]= {
            freq:cumulatedFreq,
            coeff:Number(((freqByRanges[0]+freqByRanges[1])/(freqByRanges[rangeNumber-1]+freqByRanges[rangeNumber-2])).toFixed(2)),
            lastAttestation:occTableForKey[occTableForKey.length-1].timeId
          };
      } else if (freqByRanges[0] < freqByRanges[1] && freqByRanges[rangeNumber-2] > freqByRanges[rangeNumber-1]) {
        incDecTable[key]= {
          freq:cumulatedFreq,
          coeff:Number(((freqByRanges[1]+freqByRanges[rangeNumber-2])/(freqByRanges[0]+freqByRanges[rangeNumber-1])).toFixed(2))
        };
      } else if (freqByRanges[0] > freqByRanges[1] && freqByRanges[rangeNumber-2] < freqByRanges[rangeNumber-1]) { 
        decIncTable[key]= {
          freq:cumulatedFreq,
          coeff:Number(((freqByRanges[0]+freqByRanges[rangeNumber-1])/(freqByRanges[1]+freqByRanges[rangeNumber-2])).toFixed(2))
        };
      }
    }
  }
  

// preparation of data for chronograms
export const prepChronoData = (results) => {
  const data=results.timeStats;
  data.timeIdSize=results.stats.byTimeId;


  if (! data.occs || data.occs.length===0) {
    return false
  }

  // cumulated sizes computation based on results[stats][byTimeId], which is complete
  // -> it includes timeId that could not appear in data.occs
  // be carefull : sorting timeId as string should be coherent (format YYYYMMDD with 0 padding)
  const timeIds=Object.keys(results.stats.byTimeId).sort();
  var cumulatedSize=0;
  var cumulatedSizes=[];
  for (var i=0;i<timeIds.length;i++) {
    const timeId=timeIds[i];
    cumulatedSize+=results.stats.byTimeId[timeId].size;
    cumulatedSizes[timeId]=cumulatedSize;
  }

  // computing spec for global occurrences
  var cumulatedFreq=0;
  for (i=0;i<data.occs.length;i++) {
    const [f,F,s,S]=[data.occs[i][2],data.occs[i][3],data.occs[i][4],data.occs[i][5]];
    cumulatedFreq+=f;

    // transform array in object and add specificity computation
    data.occs[i]={
      timeId:data.occs[i][1],
      freq:data.occs[i][2],
      relFreq:Number((data.occs[i][2]/s*1000000).toFixed(2)),
      cumu:cumulatedFreq,
      spec:computeLLR(f,s,F,S,true),
      timeSpec:computeLLR(f,s,cumulatedFreq,cumulatedSizes[data.occs[i][1]],true),
      size:s,
    };
  }

  // computing spec for each subCorpus
  const corpora=data.occsByCorpus? Object.keys(data.occsByCorpus):[];
  for (i=0;i<corpora.length;i++) {
    cumulatedFreq=0;
    // add specificity computation for each corpus
    const tabForCorpus=data.occsByCorpus[corpora[i]];
    for (var j=0;j<tabForCorpus.length;j++) {
      const [f,F,s,S]=[tabForCorpus[j][2],tabForCorpus[j][3],tabForCorpus[j][4],tabForCorpus[j][5]];
      cumulatedFreq+=f;
      tabForCorpus[j]={
        timeId:tabForCorpus[j][1],
        freq:tabForCorpus[j][2],
        relFreq:Number((tabForCorpus[j][2]/s*1000000).toFixed(2)),
        cumu:cumulatedFreq,
        spec:computeLLR(f,s,F,S,true),
        timeSpec:computeLLR(f,s,cumulatedFreq,cumulatedSizes[tabForCorpus[j][1]],true),
        size:s,     
      }
    }
  }
  
  // computing spec for each realization
  data.increasingReals={};
  data.decreasingReals={};
  data.incDecReals={};
  data.decIncReals={};
  updateOccTable(cumulatedSizes,data.occsByRealization,data.increasingReals,data.decreasingReals,data.incDecReals,data.decIncReals);

   // computing spec for each collocate
  data.increasingCollocs={};
  data.decreasingCollocs={};
  data.incDecCollocs={};
  data.decIncCollocs={};
  updateOccTable(cumulatedSizes,data.cooc.freqByColloc,data.increasingCollocs,data.decreasingCollocs,data.incDecCollocs,data.decIncCollocs);
 
  // Extracting a list of collocates sorted by decreasing assoc measure
  // N.B. : when we have variable realizations, a same collocate may be repeated in the list (because the key of result.cooc is realization+collocate)
  // To extract efficiently without duplicates, a hash is build and keys are then extracted, sorted by value 
  const collocs={}
  for (var nuple of results.cooc['_global_']) {
    if (data.cooc.freqByColloc && data.cooc.freqByColloc[nuple[1]]) {
      // we first check that the collocate has been recorded in cooc.freqByColloc
      if ((collocs[nuple[1]] && collocs[nuple[1]]<nuple[8]) || ! collocs[nuple[1]]) {
        collocs[nuple[1]]=nuple[8];
      }
    }
  }
  data['sortedCollocs']=Object.keys(collocs).sort( (a,b)=> collocs[b]-collocs[a] );

  // const sortedCollocs=results.cooc['_global_'].sort((a, b) => (b[8] - a[8])).map( (nuple) => { return nuple[1] })
  // data['sortedCollocs']=sortedCollocs.filter((item,index)=>index===sortedCollocs.indexOf(item));
 
  return data;
}

export const prepStatsData = (results) => {
  const statsReady = { ...results.stats };
  const concord = results.concord;

  // prepare stats data
  // notably, get the proper titles of the documents
  for (const corp in statsReady.byCorpus) {
    for (const doc in statsReady.byCorpus[corp].byDoc) {
      statsReady.byCorpus[corp].byDoc[doc]['title'] = concord.docMeta[doc].title;
    }
  }
  return statsReady;
}

export const prepReadyData = (results) => {
  const global = {
    elapsed: results.elapsed,
    lang: results.lang,
    alignedLang: results.corpus[0].aligned_language,
    nbSents2Parse: parseInt(results.stats.nbSents2Parse),// the json file may mix string and int format
    nbParsedSents: parseInt(results.stats.nbParsedSents),
  };

  return {
    query: results.query,
    subCorpora: results.corpus,
    global: global,
  };
}

export const prepCoocSpec = (results) => {
  // allow to compute global stats for cooc
  // and wordsketches
  
  // `cooc` is an array of arrays like the one below:
  //
  // [
  //   "GEN",  # corpus name
  //   "Chamson_NOUN le_DET crime_NOUN",  # expression
  //   "<l=André,c=NOUN,#co>",  # collocatif
  //   1,  # nb cooccurrences
  //   3,  # nb occurrences pivot
  //   11,  # nb occurrences collocatif
  //   305746,  # nb occurrences relation
  //   1,  # dispersion
  //   "~NMOD"  # relation
  //   2.5945307449803 # assoc
  // ],
  
  const coocSpec={};
  for (const subCorpus in results.cooc) {
    for (const i in results.cooc[subCorpus]) {
      const line=results.cooc[subCorpus][i];
      const node=line[0];
      const colloc=line[1];
  
      const key=node+"\t"+colloc;

      if (!coocSpec[key] ) {
        coocSpec[key]={};
      }
      coocSpec[key][subCorpus]=line[10];
    }
  }

  
  return coocSpec;
}

export const prepConcordData = (results) => {

  // `concord` is a object, organised by sub-subCorpora (one key by sub-corpus)
  // and one special key named `docMeta` which contains details about the document
  // in which the concordances are taken from.
  //
  // Example of the 1st concordance of a sub-corpus called "SF":
  // "SF": [
  //   {
  //     "right": ", sans plus perdre de temps, j'ai hâte de retrouver mes meubles...\\n ",
  //     "sentId": "SF/SF.fr.WALTHER.xml_3053",
  //     "node": "[[[voiture#1]]]",
  //     "left": " En ",
  //     "docId": "SF/SF.fr.WALTHER.xml#0#3253"
  //   },
  //
  // Note: the document details in `docMeta` is mostly redundant with the information
  // with get from the endpoint `get_result_meta`. Just passed to get the collection
  // the document belongs to.
  const concordsByCorpus = { ...results.concord };
  delete concordsByCorpus.docMeta;
  const attr_val_doc={};
  if ( results.concord) {
    // compute concordsByCorpus['_global_']
    if (Object.keys(results.concord).length>1) {
      concordsByCorpus['_global_']=[];
      for (const subCorpus of Object.keys(results.concord).sort()) {
        for (var i=0;i<results.concord[subCorpus].length;i++) {
          // to avoid duplicate row id, a copy of each row is created
          const newLine={
            id:"conc"+i.toString(),
            subCorpus:subCorpus,
            left:results.concord[subCorpus][i].left,
            node:results.concord[subCorpus][i].node,
            right:results.concord[subCorpus][i].right,
            docId:results.concord[subCorpus][i].docId,
            sentId:results.concord[subCorpus][i].sentId,
            pos:results.concord[subCorpus][i].pos,
          }
          if (results.queryNumber>1) {
            newLine.numQuery=results.concord[subCorpus][i].numQuery ? results.concord[subCorpus][i].numQuery : 1;
            results.concord[subCorpus][i].numQuery=results.concord[subCorpus][i].numQuery ? results.concord[subCorpus][i].numQuery : 1;
          }  
          if (results.concord[subCorpus][i].alignedSent) {
            newLine.alignedSent=results.concord[subCorpus][i].alignedSent
          }
          concordsByCorpus['_global_'].push(newLine);
        } 
      }
    }
    // console.log(concordsByCorpus['_global_']);

    // building the hash meta which records in its keys all document ID for a given attr / val pair
    for (const doc in results.concord.docMeta) {
      for (const attr in results.concord.docMeta[doc]) {
        var val=results.concord.docMeta[doc][attr];
        if (! attr_val_doc[attr]) {
          attr_val_doc[attr]={};
        }
        if (! attr_val_doc[attr][val]) {
          attr_val_doc[attr][val]={};
        }
        attr_val_doc[attr][val][doc]=1;
      }
    }
  }

  return {
    concordsByCorpus: concordsByCorpus,
    docMeta: results.concord.docMeta,
    lang: results.lang,
    aligned_language : results.aligned_language,
    concordSpan: results.params.concordSpan,
    attr_val_doc: attr_val_doc
  };
}